export default "__VITE_ASSET__14548608__"